<template>
  <div class="banner">
    <div class="background">
      <div class="container">
        <div class="txt text-center">
          <h1 class="mb-4">產品介紹</h1>
          <h2 class="mb-5">Product Description</h2>
        </div>
        <!-- <div class="button row m-4">
          <div class="button-inside m-2">
            <Button :msg="button1" @clickbutton="introduction"></Button>
          </div>
          <div class="button-inside m-2">
            <Button :msg="button2" @clickbutton="specification"></Button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
// import Button from '@/components/only_button.vue';

export default {
  data() {
    return {
      button1: '產品介紹',
      button2: '產品規格',
    };
  },
  components: {
    // Button,
  },
  methods: {
    introduction() {
      // console.log('產品介紹');
      // eslint-disable-next-line no-alert
      window.alert('產品介紹');
    },
    specification() {
      // console.log('產品規格');
      // eslint-disable-next-line no-alert
      window.alert('產品規格');
    },
  },
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 400px;
  background-image: url(https://picsum.photos/1000/500?random=26);
  background-repeat: no-repeat;
  background-size: cover;
  .background {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.3);
    .container {
      max-width: 700px;
      height: 100%;
      background-color: rgba(240, 248, 255, 0.5);
      margin-right: 10%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .txt {
        color: #fff;
        text-shadow: 0px 1px 10px #666;
        h1 {
          font-size: 3.5rem;
        }
        h2 {
          font-size: 2.5rem;
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .banner .background {
    .container {
      .txt {
        h1 {
          font-size: 4rem;
        }
        h2 {
          font-size: 2rem;
        }
      }
      .button{
        justify-content: center;
      }
    }
  }
}
</style>
